import {
  UPDATE_TRANSLATIONS,
  UPDATE_PRIVACY_POLICY_LINK,
  UPDATE_LANGUAGE_LOCALE,
} from '../constants';

export function translations(state = {}, action) {
  switch (action.type) {
    case UPDATE_TRANSLATIONS:
      return action.translationsData;
    default:
      return state;
  }
}

export function privacyPolicyLink(state = '', action) {
  switch (action.type) {
    case UPDATE_PRIVACY_POLICY_LINK:
      return action.link;
    default:
      return state;
  }
}

export function locale(state = '', action) {
  switch (action.type) {
    case UPDATE_LANGUAGE_LOCALE:
      return action.locale;
    default:
      return state;
  }
}
